// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".C4FEKIO2j0Kh4hnI2OLEIQ\\=\\={display:flex}.aJZRaqRXagNV-A67ViJdZA\\=\\={flex-wrap:wrap}", "",{"version":3,"sources":["webpack://./components/Space/styles.module.scss"],"names":[],"mappings":"AAAA,4BACE,YAAA,CAGF,4BACE,cAAA","sourcesContent":[".space {\n  display: flex;\n}\n\n.wrap {\n  flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space": "C4FEKIO2j0Kh4hnI2OLEIQ==",
	"wrap": "aJZRaqRXagNV-A67ViJdZA=="
};
export default ___CSS_LOADER_EXPORT___;
